export const environment = {
  production: false,
  // apiUrl: 'http://localhost:5000/api',
  // apiUrlOrderEngine: 'http://localhost:7000/api',
  // socketUrl: 'ws://localhost:7000',
  // digioRedirectUrl: 'http://localhost:4200/dashboard/kyc-verification',
  apiUrl: 'https://api.coinwush.com/api',
  apiUrlOrderEngine: 'https://engine.coinwush.com/api',
  socketUrl: 'wss://engine.coinwush.com',
  digioRedirectUrl: 'https://coinwush.com/dashboard/kyc-verification',
};
